import Utils from '../../utils/Utils';
import Validator from '../../utils/Validator';
import ItmMgr from '../../gui/ItmMgr';
import PSA from '../../psa';
import JsPoint from '../../utils/JsPoint';
import JsRect from '../../utils/JsRect';

const TTP_TMO = 750;
const HVR_DST = 42;
const HOT_OFS = 2;
const GID_NONE = '$NONE$';
const CLK_TMO = 150;

let tm_count = 0;

class TtpMgr {

	constructor(gcr, row) {
		this.lsrID = 'TCTMID-' + ++tm_count;
		this.dbgLog = false;
		this.gcr = gcr;
		this.row = row;
		this.tmh = null;
		this.clkTmh = null;
		this.clkPar = null;
		this.mouseEnter = Utils.bind(this, this._mouseEnter);
		this.mouseLeave = Utils.bind(this, this._mouseLeave);
		this.mouseOver = Utils.bind(this, this._mouseOver);
		this.onTimer = Utils.bind(this, this._onTimer);
		this.row.addEventListener('mouseenter', this.mouseEnter);
		this.row.addEventListener('mouseleave', this.mouseLeave);
		this.row.addEventListener('mouseover', this.mouseOver);
		this.curPos = new JsPoint(-1, -1);
		this.lstTgt = null;
		this.bscVis = false;
		this.bscMgr = PSA.getInst().getBscMgr();
		if ( this.bscMgr ) {
			this.bscMgr.addBscLsr(this);
		}
		this.qvwMgr = PSA.getInst().getQvwMgr();
		if ( this.qvwMgr ) {
			this.qvwMgr.addQvwLsr(this);
		}
		this.ttpGid = GID_NONE;
	}

	destroy() {
		if ( this.qvwMgr ) {
			this.qvwMgr.rmvQvwLsr(this);
		}
		if ( this.bscMgr ) {
			this.bscMgr.rmvBscLsr(this);
		}
		if ( this.clkTmh ) {
			clearTimeout(this.clkTmh);
		}
		delete this.clkTmh;
		delete this.clkPar;
		this._clrTmr();
		this.row.removeEventListener('mouseenter', this.mouseEnter);
		this.row.removeEventListener('mouseleave', this.mouseLeave);
		this.row.removeEventListener('mouseover', this.mouseOver);
		delete this.mouseEnter;
		delete this.mouseLeave;
		delete this.mouseOver;
		delete this.onTimer;
		delete this.tmh;
		delete this.bscMgr;
		delete this.qvwMgr;
		delete this.curPos;
		delete this.lstTgt;
		delete this.row;
		delete this.gcr;
	}

	init() {
		this._clrTmr();
		if ( this.qvwMgr && !this.qvwMgr.isQvwDis() ) {
			this._logMsg('init');
			this.tmh = setTimeout(this.onTimer, TTP_TMO);
		}
	}

	stop(all) {
		this._logMsg('stop(' + all + ')');
		this._clrTmr();
		this.lstTgt = null;
		if ( !!all && this.qvwMgr ) {
			this.qvwMgr.frcQvwHid();
			this.ttpGid = GID_NONE;
		}
	}

	getLsrKey() {
		return this.lsrID;
	}

	onBscShow(show) {
		this.bscVis = !!show;
		this._logMsg('BSC ' + (this.bscVis ? 'show' : 'hide'));
	}

	onQvwShow(show) {
		if ( show ) {
			this._logMsg('qvw SHOW');
		} else {
			this._logMsg('qvw HIDE');
			this.ttpGid = GID_NONE;
		}
	}

	onItemClick(scope, dbl, par) {
		this.stop(true);
		const clp = {};
		clp.dbl = !!dbl;
		clp.par = par || {};
		clp.scope = scope;
		this.clkPar = clp;
		if ( !this.clkTmh ) {
			const self = this;
			this.clkTmh = setTimeout(() => {
				self._onItemClick();
			}, CLK_TMO);
		}
	}

	_isDbgLog() {
		return this.dbgLog;
	}

	_logMsg(msg) {
		if ( this._isDbgLog() ) {
			const now = new Date();
			PSA.getInst().Log.getConsole(false).log(now.toISOString() + ' (' + this.lsrID + ') - TCE: ' + msg);
		}
	}

	_onItemClick() {
		const clp = this.clkPar;
		this.clkPar = null;
		this.clkTmh = null;
		this.stop(true);
		clp.scope._nfySrv(clp.dbl ? 'dblClk' : 'itmClk', clp.par);
	}

	_clrTmr() {
		if ( this.tmh ) {
			const tmh = this.tmh;
			this.tmh = null;
			clearTimeout(tmh);
		}
	}

	_getTarget(e) {
		let tgt = null;
		if ( document.elementFromPoint ) {
			tgt = document.elementFromPoint(e.clientX, e.clientY);
			if ( tgt ) {
				while ( tgt && (tgt != this.row) && !tgt.__ci ) {
					tgt = tgt.parentElement;
				}
				if ( !tgt || !tgt.__ci ) {
					tgt = null;
				}
			}
		}
		return tgt ? tgt : e.target;
	}

	_mouseEnter(e) {
		this._logMsg('mouseenter --> init');
		this.curPos.x = e.clientX;
		this.curPos.y = e.clientY;
		if ( this.qvwMgr ) {
			this.qvwMgr.updCurPos(e.clientX, e.clientY);
		}
		this.lstTgt = this._getTarget(e);
		this.init();
	}

	_mouseLeave(e) {
		if ( !this.bscVis ) {
			this._logMsg('mouseleave --> STOP!');
			this.stop(true);
			this.curPos.x = -1;
			this.curPos.y = -1;
		} else {
			this._logMsg('mouseleave --> ignored due to block screen.');
		}
	}

	_mouseOver(e) {
		if ( !this.tmh ) {
			this._mouseEnter(e);
		}
		const x = e.clientX;
		const y = e.clientY;
		if ( (Math.abs(this.curPos.x - x) > HVR_DST) || (Math.abs(this.curPos.y - y) > HVR_DST) ) {
			this.stop(false);
		}
		this.curPos.x = x;
		this.curPos.y = y;
		if ( this.qvwMgr ) {
			this.qvwMgr.updCurPos(x, y);
		}
		this.lstTgt = this._getTarget(e);
	}

	_onTimer() {
		this._logMsg('QVW timer event - GID="' + this.ttpGid + '".');
		this._clrTmr();
		if ( this.lstTgt && this.lstTgt.__ci ) {
			const gid = this.lstTgt.__ci.gid;
			if ( this.qvwMgr && !this.qvwMgr.isQvwDis() && (this.ttpGid !== gid) ) {
				this.qvwMgr.frcQvwHid();
				this._logMsg('sending QVW request for "' + gid + '"...');
				this.ttpGid = gid;
				const par = {};
				const pos = this.qvwMgr.getCurPos();
				if ( pos ) {
					this.curPos = pos;
				}
				par.clx = this.curPos.x;
				par.cly = this.curPos.y;
				par.gid = gid;
				const bcr = this.lstTgt.getBoundingClientRect();
				const rct = [];
				rct[0] = Math.round(bcr.left - HOT_OFS);
				rct[1] = Math.round(bcr.top - HOT_OFS);
				rct[2] = Math.round(bcr.width + 2 * HOT_OFS);
				rct[3] = Math.round(bcr.height + 2 * HOT_OFS);
				par.rct = rct;
				this.gcr._nfySrv('ttpRqu', par);
			} else {
				this._logMsg('QVW request REJECTED for "' + gid + '".');
			}
		}
		this.stop(false);
	}
}

// --- Event helper functions (from GcrEvt.js) ---

function _getEvtPar(evt) {
	const par = {};
	par.btn = evt.button;
	par.ctr = evt.ctrlKey || false;
	par.sft = evt.shiftKey || false;
	par.alt = evt.altKey || false;
	par.scx = evt.screenX;
	par.scy = evt.screenY;
	par.clx = evt.clientX;
	par.cly = evt.clientY;
	return par;
}

function handleItemClick(evt, scope, ci, dbl, ctx) {
	const par = _getEvtPar(evt);
	par.gid = ci.gid;
	par.ctx = !!ctx;
	const bcr = ci.$el.getBoundingClientRect();
	par.itr = new JsRect(Math.round(bcr.x), Math.round(bcr.y), Math.round(bcr.width), Math.round(bcr.height));
	evt.preventDefault();
	evt.stopPropagation();
	scope.ttpMgr.onItemClick(scope, dbl, par);
}

function handleGlobalClick(evt, scope) {
	const par = _getEvtPar(evt);
	evt.preventDefault();
	evt.stopPropagation();
	scope.ttpMgr.stop(true);
	scope._nfySrv('rowClk', par);
}

function handleGlobalDblClk(evt, scope) {
	rmvClkRct(scope);
	const par = _getEvtPar(evt);
	const sr = scope.row.getBoundingClientRect();
	par.prdbeg = scope.prdBeg;
	par.prdend = scope.prdEnd;
	const rct = [];
	rct[0] = Math.round(sr.left);
	rct[1] = Math.round(sr.top);
	rct[2] = Math.round(sr.width);
	rct[3] = Math.round(sr.height);
	par.rct = rct;
	evt.preventDefault();
	evt.stopPropagation();
	scope.ttpMgr.stop(true);
	scope._nfySrv('rowDbc', par);
}

function handleMouseDown(evt, scope, ci) {
	if ( !evt.shiftKey ) return;
	evt.stopPropagation();
	const rect = ci.$el.getBoundingClientRect();
	ci.mosXstr = evt.clientX;
	ci.mosYstr = evt.clientY;
	ci.mosXend = null;
	ci.mosYend = null;
	ci.apmXstr = rect.left || rect.x;
	ci.apmXend = rect.left ? rect.left + rect.width : rect.x + rect.width;
	ci.apmXWdt = rect.width;
	ci.apmStlWdt = ci.$el.style.width;
	ci.apmYstr = rect.top || rect.y;
	ci.apmYend = rect.top ? rect.top + rect.height : rect.y + rect.height;
	ci.apmYHgt = rect.height;
	scope.isCi = true;
	scope.drgCi = ci;
	ci.isAtMrg = isAtMrg(ci.mosXstr, ci.apmXstr, ci.apmXend, 6);
	scope.ttpMgr.stop(true);
}

function handleRowMouseDown(evt, scope) {
	if ( scope.isCi || !evt.ctrlKey ) return;
	scope.mosDwn = true;
	rmvClkRct(scope);
	updBeg(scope, evt);
	scope.ttpMgr.stop(true);
}

function handleRowMouseMove(evt, scope) {
	if ( !scope.mosDwn && !scope.isCi && !scope.drgCi ) return;
	if ( scope.isCi && scope.drgCi ) {
		mouseMoveItem(evt, scope, scope.drgCi);
	} else {
		updEnd(scope, evt);
		rmvClkRct(scope);
		crtClkRct(scope, evt);
	}
}

function handleRowMouseUp(evt, scope) {
	if ( scope.mosDwn ) {
		scope.mosDwn = false;
		const par = clcPar(scope);
		rmvClkRct(scope);
		rstMosPos(scope);
		par ? scope._nfySrv('newApm', par) : void 0;
	} else {
		mouseUpItem(evt, scope, scope.drgCi, 'row');
	}
}

function mouseMoveItem(evt, scope, ci) {
	ci.mosXend = evt.clientX;
	scope.drgCi.mosYend = evt.clientY;
	const difX = ci.mosXend - ci.mosXstr;
	const difY = scope.drgCi.mosYend - scope.drgCi.mosYstr;
	if ( Math.abs(difX) < 5 && Math.abs(difY) < 5 ) return;
	const vrt = Math.abs(difY) &&
		((Math.abs(difX) && Math.abs(difY) > Math.abs(difX)) || !Math.abs(difX)) &&
		(scope.drgCi.mosYend < scope.drgCi.apmYstr || scope.drgCi.mosYend > scope.drgCi.apmYend);
	rmvMovApmOvl(scope);
	if ( ci.isAtMrg && (ci.isAtMrg.str || ci.isAtMrg.end) ) {
		ci.$el.style.cursor = "col-resize";
		scope.row.style.cursor = "col-resize";
		crtRszOvl(scope, ci);
	} else if ( vrt ) {
		scope.isVrt = true;
		crtNewMbrOvl(scope, ci);
	} else {
		crtMovApmOvl(scope, ci);
	}
}

function mouseUpItem(evt, scope, ci, opr) {
	scope = fndCiRow(scope) ? fndCiRow(scope) : scope;
	ci = scope ? scope.drgCi : ci;
	if ( evt.shiftKey && scope.isVrt && scope.curRow && scope != scope.curRow ) {
		const par = {};
		par.gid = ci.gid;
		par.rid = scope.curRow.rowID;
		par.wid = scope.curRow.wdgId;
		par.evt = _getEvtPar(evt);
		par.orgbeg = ci.beg;
		par.orgend = ci.end;
		par.opr = opr || '';
		par ? scope._nfySrv('addApmMmb', par) : void 0;
	} else if ( evt.shiftKey ) {
		const par = clcPar(scope, scope.cldCmp.movApmOvl, ci);
		if ( par ) {
			par.evt = _getEvtPar(evt);
			par.orgbeg = ci.beg;
			par.orgend = ci.end;
			par.opr = opr || '';
			scope._nfySrv('movApm', par);
		}
	}
	rmvMovApmOvl(scope);
	clrCiPrp(scope, ci);
	scope.row.style.cursor = "default";
}

function mouseOverItem(evt, scope, ci) {
	const mosX = evt.clientX;
	const rect = ci.$el.getBoundingClientRect();
	const apmXstr = rect.left || rect.x;
	const apmXend = rect.left ? rect.left + rect.width : rect.x + rect.width;
	const mrg = isAtMrg(mosX, apmXstr, apmXend, 6);
	if ( mrg && (mrg.str || mrg.end) ) {
		ci.$el.style.cursor = "col-resize";
	} else {
		ci.$el.style.cursor = "pointer";
	}
}

function mouseOutItem(evt, scope, ci) {
	ci.$el.style.cursor = null;
}

function cpyStlTo(src, dst, stlAtr) {
	if ( !src || !dst || !stlAtr || stlAtr.length == 0 || typeof stlAtr != "object" ) return;
	src.$el ? src = src.$el : void 0;
	if ( !(src instanceof HTMLElement) ) {
		console.warn(src + "is not a HTML element");
	}
	if ( !(dst instanceof HTMLElement) ) {
		console.warn(dst + "is not a HTML element");
	}
	if ( !src.style || !dst.style ) {
		return;
	}
	stlAtr.forEach(atr => {
		dst.style[atr] = src.style[atr];
	});
}

function isAtMrg(xCrd, str, end, min) {
	return {
		str: Math.abs(xCrd - str) < min,
		end: Math.abs(xCrd - end) < min
	};
}

function fndCiRow(scope) {
	for ( let row of scope.cldCmp.rowReg.getValues() ) {
		if ( row.drgCi && row.isCi ) {
			return row;
		}
	}
	return null;
}

function crtNewMbrOvl(scope, ci) {
	const ovl = document.createElement('div');
	const mouseup = function(e) { mouseUpItem(e, scope, scope.drgCi, 'newmmb'); };
	const mousemove = function(e) { mouseMoveItem(e, scope, scope.drgCi); };
	ovl.addEventListener('mouseup', mouseup);
	ovl.addEventListener('mousemove', mousemove);
	const mgl = ci.apmXstr - scope.cldCmp.parDiv.getBoundingClientRect().left;
	ovl.style.marginLeft = `${mgl}px`;
	ovl.style.width = `${ci.apmXWdt}px`;
	ovl.style.height = "100%";
	ovl.style.position = "absolute";
	ovl.style.zIndex = "500";
	ovl.style.cursor = "move";
	const row = fndCrtRow(scope, ci);
	row ? scope.curRow = row : void 0;
	const rct = (row && row.row) ? row.row.getBoundingClientRect() : (row ? row.getBoundingClientRect() : null);
	if ( rct ) {
		const CPY_ATR = [ "backgroundColor", "border", "font", "color", "fontFamily", "fontSize", "fontColor" ];
		const rtt = rct.top || rct.y;
		const ptt = scope.cldCmp.parDiv.getBoundingClientRect().top || scope.cldCmp.parDiv.getBoundingClientRect().y;
		const hgt = rct.height;
		const dit = document.createElement('div');
		cpyStlTo(scope.drgCi.$el, dit, CPY_ATR);
		dit.style.height = `${hgt}px`;
		dit.style.marginTop = `${rtt - ptt}px`;
		dit.innerHTML = ci.$el.innerHTML;
		dit.style.width = "100%";
		dit.style.textAlign = "center";
		dit.style.opacity = "0.7";
		dit.style.cursor = "move";
		ovl.appendChild(dit);
	}
	scope.cldCmp.parDiv.appendChild(ovl);
	scope.cldCmp.movApmOvl = ovl;
}

function crtRszOvl(scope, ci) {
	const ovl = document.createElement('div');
	let mgl = 0;
	let wdt = 0;
	if ( ci.isAtMrg.str ) {
		mgl = ci.apmXstr + ci.mosXend - ci.mosXstr - scope.cldCmp.parDiv.getBoundingClientRect().left;
		wdt = ci.apmXWdt + ci.mosXstr - ci.mosXend;
	} else if ( ci.isAtMrg.end ) {
		mgl = ci.apmXstr - scope.cldCmp.parDiv.getBoundingClientRect().left;
		wdt = ci.apmXWdt + ci.mosXend - ci.mosXstr;
	} else return;
	const mouseup = function(e) { mouseUpItem(e, scope, scope.drgCi, 'resize'); };
	const mousemove = function(e) { mouseMoveItem(e, scope, scope.drgCi); };
	ovl.addEventListener('mouseup', mouseup);
	ovl.addEventListener('mousemove', mousemove);
	ovl.style.marginLeft = `${mgl}px`;
	ovl.style.width = `${wdt}px`;
	ovl.style.height = "100%";
	ovl.style.position = "absolute";
	ovl.style.zIndex = "500";
	ovl.style.cursor = "col-resize";
	addCldEvt(ovl, scope, ci, false);
	scope.cldCmp.parDiv.appendChild(ovl);
	scope.cldCmp.movApmOvl = ovl;
}

function crtMovApmOvl(scope, ci) {
	const ovl = document.createElement('div');
	const mgl = ci.apmXstr + ci.mosXend - ci.mosXstr - scope.cldCmp.parDiv.getBoundingClientRect().left;
	const mouseup = function(e) { mouseUpItem(e, scope, scope.drgCi, 'move'); };
	const mousemove = function(e) { mouseMoveItem(e, scope, scope.drgCi); };
	const row = fndCrtRow(scope, ci);
	row ? scope.curRow = row : void 0;
	ovl.addEventListener('mouseup', mouseup);
	ovl.addEventListener('mousemove', mousemove);
	ovl.style.marginLeft = `${mgl}px`;
	cpyStlTo(ci.$el, ovl, [ "width" ]);
	ovl.style.height = "100%";
	ovl.style.position = "absolute";
	ovl.style.zIndex = "500";
	ovl.style.cursor = "move";
	addCldEvt(ovl, scope, ci);
	scope.cldCmp.parDiv.appendChild(ovl);
	scope.cldCmp.movApmOvl = ovl;
}

function addCldEvt(prt, scope, ci, opc = true) {
	const CPY_ATR = [ "backgroundColor", "border", "font", "color", "fontFamily", "fontSize", "fontColor" ];
	let prvMrg = 0;
	const prtTop = scope.cldCmp.parDiv.getBoundingClientRect().top || scope.cldCmp.parDiv.getBoundingClientRect().y;
	fndSmlCi(scope, ci).forEach(itm => {
		const dit = document.createElement('div');
		const itmHgt = itm.$el.getBoundingClientRect().height;
		const itmTop = itm.$el.getBoundingClientRect().top || itm.$el.getBoundingClientRect().y;
		const mrg = itmTop - prtTop - prvMrg;
		prvMrg = prvMrg + itmHgt + mrg;
		cpyStlTo(ci.$el, dit, CPY_ATR);
		dit.style.height = `${itmHgt}px`;
		dit.style.marginTop = `${mrg}px`;
		dit.innerHTML = ci.$el.innerHTML;
		dit.style.width = "100%";
		dit.style.textAlign = "center";
		opc ? dit.style.opacity = "0.7" : void 0;
		opc ? dit.style.cursor = "move" : dit.style.cursor = "col-resize";
		!opc ? itm.$el.style.opacity = "0" : void 0;
		prt.appendChild(dit);
	});
}

function fndSmlCi(scope, ci) {
	const its = [];
	if ( !ci || !ci.gid ) return its;
	for ( let row of getRwsArr(scope) ) {
		if ( !row.cldItm ) continue;
		for ( let itm of row.cldItm ) {
			if ( itm.gid == ci.gid ) {
				itm.prt = row;
				its.push(itm);
				break;
			}
		}
	}
	return its;
}

function fndCrtRow(scope, ci) {
	if ( !scope || !scope.row || !(scope.drgCi || ci) || !(scope.drgCi.mosYend || ci.mosYend) ) return;
	const mosY = scope.drgCi && scope.drgCi.mosYend ? scope.drgCi.mosYend : ci.mosYend;
	for ( let row of getRwsArr(scope) ) {
		const rct = row.row ? row.row.getBoundingClientRect() : row.getBoundingClientRect();
		const top = rct.top || rct.y;
		const btm = rct.top ? rct.top + rct.height : rct.y + rct.height;
		if ( mosY > top && mosY <= btm ) return row;
	}
	return null;
}

function getRwsArr(row) {
	if ( !row || !row.cldCmp || !row.cldCmp.rowReg ) {
		return [];
	}
	return row.cldCmp.rowReg.getValues();
}

function rmvMovApmOvl(scope) {
	if ( !scope || !scope.cldCmp || !scope.cldCmp.movApmOvl ) return;
	const ovl = scope.cldCmp.movApmOvl;
	scope.cldCmp.movApmOvl = null;
	if ( !scope.cldCmp.parDiv ) return;
	ovl ? scope.cldCmp.parDiv.removeChild(ovl) : void 0;
}

function clrCiPrp(scope, ci) {
	if ( !scope && !ci ) return;
	scope ? scope.isCi = false : void 0;
	scope ? scope.drgCi = null : void 0;
	scope ? scope.isVrt = false : void 0;
	scope ? scope.curRow = null : void 0;
	if ( !ci ) return;
	ci.mosDwn = false;
	ci.mosXstr = null;
	ci.mosXend = null;
	ci.apmXstr = null;
	ci.apmXend = null;
	ci.apmXWdt = null;
	ci.apmStlWdt = null;
	ci.mosYend = null;
	ci.apmYstr = null;
	ci.apmYend = null;
	ci.apmYHgt = null;
	ci.isAtMrg = null;
}

function clcPar(scope, rct = null, ci = null) {
	if ( (!scope.row || !scope.tmpRct) && !scope.drgCi ) return;
	const sr = scope.row.getBoundingClientRect();
	const tr = rct ? rct.getBoundingClientRect() : (scope.tmpRct ? scope.tmpRct.getBoundingClientRect() : (scope.drgCi ? scope.drgCi.$el.getBoundingClientRect() : null));
	if ( !tr ) return;
	const dur = scope.prdEnd - scope.prdBeg;
	const trBeg = (tr.x && sr.x) ? (tr.x - sr.x) / sr.width : (tr.left - sr.left) / sr.width;
	const trEnd = (tr.x && sr.x) ? (tr.x + tr.width - sr.x) / sr.width : (tr.left + tr.width - sr.left) / sr.width;
	const trWdt = tr.width / sr.width;
	const begTim = scope.prdBeg + dur * trBeg;
	const endTim = scope.prdBeg + dur * trEnd;
	const durTim = dur * trWdt;
	const par = {};
	par.beg = endTim - parseInt(begTim) > 0.5 ? parseInt(begTim) + 1 : parseInt(begTim);
	par.end = endTim - parseInt(endTim) > 0.5 ? parseInt(endTim) + 1 : parseInt(endTim);
	par.dur = durTim - parseInt(durTim) > 0.5 ? parseInt(durTim) + 1 : parseInt(durTim);
	par.wdt = sr.width;
	scope.drgCi ? par.gid = scope.drgCi.gid : void 0;
	return par;
}

function updBeg(scope, evt = null) {
	if ( !evt ) {
		scope.mosXbeg = null;
		scope.mosYbeg = null;
	} else {
		scope.mosXbeg = evt.clientX;
		scope.mosYbeg = evt.clientY;
	}
}

function updEnd(scope, evt = null) {
	if ( !evt ) {
		scope.mosXend = null;
		scope.mosYend = null;
	} else {
		scope.mosXend = evt.clientX;
		scope.mosYend = evt.clientY;
	}
}

function rstMosPos(scope) {
	updBeg(scope);
	updEnd(scope);
}

function rmvClkRct(scope) {
	if ( !scope.tmpRct ) return;
	const rct = scope.tmpRct;
	scope.tmpRct = null;
	scope.row.removeChild(rct);
}

function crtClkRct(scope, evt) {
	if ( scope.mosXend - scope.mosXbeg < 5 ) return;
	const rct = document.createElement('div');
	const row = scope.row || evt.srcElement || evt.target || evt.path[0] || scope.ttpMgr.row;
	if ( !row ) return;
	const lft = row.getBoundingClientRect().left || row.getBoundingClientRect().x;
	const mgl = pixToPrc(scope.mosXbeg - lft, row);
	const wdt = pixToPrc(scope.mosXend - scope.mosXbeg, row);
	rct.style.marginTop = "0px";
	rct.style.marginLeft = `${mgl}%`;
	rct.style.width = `${wdt}%`;
	rct.style.height = "100%";
	setElmUi(rct);
	row.appendChild(rct);
	scope.tmpRct = rct;
}

function pixToPrc(pixVal, row) {
	const rowRct = row.getBoundingClientRect();
	if ( !rowRct || !rowRct.width ) return;
	return pixVal * 100.0 / rowRct.width;
}

function setElmUi(elm) {
	elm.style.position = "absolute";
	elm.style.zIndex = "3000";
	elm.style.backgroundColor = "rgba(0, 150, 136, 0.4)";
	elm.style.borderColor = "rgb(0, 150, 136)";
	elm.style.borderWidth = "0.5px";
	elm.style.borderStyle = "solid";
}

// --- Layout helper functions (from GcrLay.js) ---

function assignRow(rows, ci) {
	const rc = rows.length;
	let row = null;
	for ( let i = 0; !row && (i < rc); ++i ) {
		const r = rows[i];
		if ( r.bl.length > 0 ) {
			const b = r.bl[r.bl.length - 1];
			if ( b.end <= ci.beg ) {
				row = r;
				r.bl.push(ci);
			}
		}
	}
	if ( !row ) {
		row = { idx: rc, bl: [] };
		row.bl.push(ci);
		rows.push(row);
	}
	ci.row = row;
}

function overlapp(ci1, ci2) {
	return (ci1.beg < ci2.end) && (ci2.beg < ci1.end);
}

function placeItem(rows, ci) {
	const rc = rows.length;
	const rix = ci.row.idx;
	let ovr = 0;
	ci.$el.style.top = '' + ((100.0 * rix) / rc) + '%';
	if ( rix < (rc - 1) ) {
		for ( let i = rix + 1; !ovr && (i < rc); ++i ) {
			const r = rows[i];
			const bc = r.bl.length;
			for ( let k = 0; !ovr && (k < bc); ++k ) {
				const b = r.bl[k];
				if ( b.beg > ci.end ) {
					break;
				} else if ( overlapp(ci, b) ) {
					ovr = i;
				}
			}
		}
		if ( !ovr ) {
			ovr = rc;
		}
	} else {
		ovr = rc;
	}
	ci.$el.style.height = '' + (100.0 * (ovr - rix) / rc) + '%';
}

// --- GrcRow class ---

export default class GrcRow {

	constructor(properties) {
		Utils.bindAll(this, [ "layout", "onReady", "onRender" ]);
		this.ready = false;
		this.cldId = '';
		this.rowID = 0;
		this.cldCmp = null;
		this.lstRow = false;
		this.shoDon = false;
		this.shoCan = false;
		this.nowBgc = null;
		this.nowFgc = null;
		this.nowBrc = null;
		this.brdClr = null;
		this.lbdClr = null;
		this.stgClr = null;
		this.itmFnt = null;
		this.prdBeg = 0;
		this.prdEnd = 0;
		this.blkDur = 0;
		this.cldBlk = [];
		this.cldItm = [];
		this.pndData = null;
		this.nowBlk = null;
		const idw = properties.parent || '';
		this.wdgId = idw;
		this.parent = rap.getObject(idw);
		const cnt = document.createElement('div');
		cnt.className = 'gccontainer';
		cnt.style.display = 'flex';
		cnt.style.flexDirection = 'row';
		cnt.style.zIndex = 101;
		const row = document.createElement('div');
		row.className = 'gccrow';
		row.style.zIndex = 1001;
		this.container = cnt;
		this.row = row;
		this.parent.append(this.container);
		this.parent.append(this.row);
		const cwd = this.parent.getData("pisasales.CSTPRP.CWD") || {};
		this._init(cwd);
		this.parent.addListener("Resize", this.layout);
		rap.on("render", this.onRender);
	}

	destroy() {
		this._cleanup();
		this.parent = null;
		this.ready = false;
	}

	getIdw() {
		return this.wdgId;
	}

	onReady() {
		this.ready = true;
		if ( Validator.isString(this.cldId) ) {
			const cmp = PSA.getInst().glbWdgReg.getObj(this.cldId);
			if ( cmp ) {
				this.cldCmp = cmp;
				this.cldCmp.addRow(this);
			}
		}
	}

	onRender() {
		if ( this.container && this.container.parentNode ) {
			rap.off("render", this.onRender);
			this.onReady();
			this.layout();
			if ( this.pndData ) {
				const data = this.pndData;
				delete this.pndData;
				this._creNewItms(data);
			}
		}
	}

	layout() {
		this.onNfyRsz();
	}

	_init(args) {
		const mgr = ItmMgr.getInst();
		if ( args.brdclr ) {
			this.brdClr = mgr.getRgb(args.brdclr);
		}
		if ( args.lbdclr ) {
			this.lbdClr = mgr.getRgb(args.lbdclr);
		}
		if ( args.stgclr ) {
			this.stgClr = mgr.getRgb(args.stgclr);
		}
		if ( args.nowbgc ) {
			this.nowBgc = mgr.getRgb(args.nowbgc);
		} else {
			this.nowBgc = 'rgba(255, 122, 0, 0.25)';
		}
		if ( args.nowfgc ) {
			this.nowFgc = mgr.getRgb(args.nowfgc);
		} else {
			this.nowFgc = 'rgb(255, 122, 0)';
		}
		if ( args.nowbrc ) {
			this.nowBrc = mgr.getRgb(args.nowbrc);
		} else {
			this.nowBrc = 'rgb(255, 143, 41)';
		}
		if ( args.fnt ) {
			this.itmFnt = args.fnt;
		}
		this.cldId = args.icd || '';
		this._addGlbLis();
	}

	_cleanup() {
		this._dropOldItms();
		if ( this.cldCmp ) {
			const cmp = this.cldCmp;
			this.cldCmp = null;
			cmp.rmvRow(this);
		}
		delete this.cldBlk;
		delete this.cldItm;
		if ( this.ttpMgr ) {
			const tmg = this.ttpMgr;
			delete this.ttpMgr;
			tmg.destroy();
		}
		this.ready = false;
		this.container = null;
		this.row = null;
	}

	_nfySrv(code, par) {
		if ( this.ready ) {
			const param = {};
			param.cod = code;
			param.par = par;
			rap.getRemoteObject(this).notify("GRC_ROW_NFY", param);
		}
	}

	_clrNowBlk(all) {
		if ( this.nowBlk ) {
			const nbl = this.nowBlk;
			if ( nbl.ndiv ) {
				nbl.ndiv.parentNode.removeChild(nbl.ndiv);
				nbl.ndiv = null;
			}
			if ( all ) {
				delete this.nowBlk;
				this.nowBlk = null;
			}
		}
	}

	_addBlk(b, d, s) {
		const blk = {};
		blk.tms = b.tms;
		blk.div = d;
		blk.sub = s;
		this.cldBlk.push(blk);
	}

	_creBlocks(blocks, nam) {
		const mgr = ItmMgr.getInst();
		delete this.cldBlk;
		this.cldBlk = [];
		this._clrNowBlk(true);
		const is_day = ('DAY' === nam) || ('MONTH' === nam);
		const is_qrt = !is_day && ('QUARTER' === nam);
		const c = this.container;
		const l = blocks.length;
		c.innerHTML = '';
		const base = 100.0 / l;
		for ( let i = 0; i < l; ++i ) {
			const b = blocks[i];
			const is_last = (i === (l - 1));
			const is_now = b.now;
			const nxt_now = !is_now && !is_last && blocks[i + 1].now;
			let brc_btm = null;
			let brc_rgt = this.brdClr;
			const is_oop = !is_now && b.oop;
			if ( !is_now && !nxt_now && b.stg && !is_last && this.stgClr ) {
				brc_rgt = this.stgClr;
			}
			const o = document.createElement('div');
			o.className = 'gccblock' + (is_now ? ' gcnow' : (is_oop ? ' gcoop' : ''));
			o.style.flexBasis = '' + base + '%';
			if ( brc_btm ) {
				o.style.borderBottom = '1px solid ' + brc_btm;
			}
			if ( brc_rgt ) {
				o.style.borderRight = '1px solid ' + brc_rgt;
			}
			if ( this.blkDur && is_now ) {
				this.nowBlk = { idx: i, bdiv: o, tms: b.tms, ndiv: null };
			}
			const sub_nfo = [];
			if ( b.sub && b.sub.length > 0 ) {
				const sl = b.sub.length;
				const sb = 100.0 / sl;
				const sub_brc = this.lbdClr;
				const sub_typ = 'solid';
				for ( let k = 0; k < sl; ++k ) {
					const sub = b.sub[k];
					const sd = document.createElement('div');
					sd.className = 'gcbsubitem';
					if ( !is_qrt ) {
						sd.className += ' gcb' + sub.srn;
						if ( (k % 2) !== 0 ) {
							sd.className += '1';
						} else {
							if ( (k % 4) !== 0 ) {
								sd.className += '2';
							} else {
								sd.className += '4';
							}
						}
					}
					sd.style.flexBasis = '' + sb + '%';
					sub_nfo.push({ div: sd, tms: sub.tms });
					let eff_brr = null;
					if ( sub_brc && (k < (sl - 1)) ) {
						eff_brr = '1px ' + sub_typ + ' ' + sub_brc;
					}
					if ( is_qrt ) {
						const sub_now = sub.now || false;
						const sub_oop = sub.oop || false;
						if ( sub_oop ) {
							sd.className += ' gcoop';
						} else if ( this.blkDur && sub_now ) {
							sd.className += ' gcnow';
							eff_brr = null;
							this.nowBlk = { idx: i, bdiv: sd, tms: b.tms, ndiv: null };
						}
					}
					if ( Validator.isString(eff_brr) ) {
						sd.style.borderRight = eff_brr;
					}
					o.appendChild(sd);
				}
			}
			this._addBlk(b, o, sub_nfo);
			c.appendChild(o);
		}
	}

	_fndBlk(tms) {
		let last = null;
		if ( this.cldBlk && this.cldBlk.length ) {
			const cb = this.cldBlk;
			last = cb[0];
			const lim = cb.length;
			let chk = cb[0];
			for ( let i = 0; (i < lim) && (chk.tms <= tms); ++i ) {
				last = chk;
				chk = cb[i];
			}
		}
		if ( last && last.sub && (last.sub.length > 0) ) {
			const sb = last.sub;
			const lim = sb.length;
			let chk = sb[0];
			let ls = sb[0];
			for ( let i = 0; (i < lim) && (chk.tms <= tms); ++i ) {
				ls = chk;
				chk = sb[i];
			}
			last = ls;
		}
		return last;
	}

	_getCorFct(div, tms, wdt, ofs) {
		const prd_len = 10.0 * (this.prdEnd - this.prdBeg);
		let cor = 1.0;
		const x = div.getBoundingClientRect().left - ofs;
		if ( x > 0 ) {
			const e = ((10.0 * (tms - this.prdBeg)) / prd_len) * wdt;
			if ( e !== 0 ) {
				cor = x / e;
			}
		}
		return cor;
	}

	_setItmVis(ci) {
		const sta = ci.sta;
		if ( Validator.isString(sta) && (sta !== 'OPN') ) {
			const oop = !!ci.oop;
			let vis = !oop;
			if ( sta === 'CAN' ) {
				vis = this.shoCan;
			} else if ( sta === 'DON' ) {
				vis = this.shoDon;
			}
			ci.vis = vis;
			ci.$el.style.display = !oop && vis ? '' : 'none';
		}
	}

	_updAllVis() {
		if ( this.cldItm.length > 0 ) {
			const cil = this.cldItm;
			const cnt = cil.length;
			for ( let i = 0; i < cnt; ++i ) {
				this._setItmVis(cil[i]);
			}
			this._updItmLay(this.cldItm);
		}
	}

	_creCldItm(mgr, ci, wdt, hgt, ofs) {
		const cd = document.createElement('div');
		cd.className = 'gccitem';
		mgr.setBkgClr(cd, ci.bgc, false);
		cd.style.border = '1px solid ' + mgr.getRgb(ci.brc);
		let cor = 1.0;
		const prd_len = 10.0 * (this.prdEnd - this.prdBeg);
		const blk = this._fndBlk(ci.beg);
		if ( blk ) {
			cor = this._getCorFct(blk.div, blk.tms, wdt, ofs);
		}
		cd.style.top = '0px';
		cd.style.height = '100%';
		ci.oop = false;
		let eff_len = ci.end - ci.beg;
		if ( (ci.end < this.prdBeg) || (ci.beg > this.prdEnd) ) {
			eff_len = 0;
			ci.oop = true;
		} else if ( ci.beg < this.prdBeg ) {
			eff_len = ci.end - this.prdBeg;
			cd.style.borderLeft = 'none';
			cd.style.left = '0px';
		} else {
			cd.style.left = '' + ((cor * 1000.0 * (ci.beg - this.prdBeg)) / prd_len) + '%';
		}
		cd.style.width = '' + ((cor * 1000.0 * eff_len) / prd_len) + '%';
		if ( !ci.oop && (ci.end > this.prdEnd) ) {
			cd.style.borderRight = 'none';
			cd.style.width = '100%';
		}
		if ( this.itmFnt ) {
			mgr.setFnt(cd, this.itmFnt);
		}
		if ( Validator.isString(ci.txt) ) {
			const st = document.createElement('span');
			st.className = 'gccitem';
			st.innerText = ci.txt;
			if ( ci.fgc ) {
				mgr.setFgrClr(st, ci.fgc);
			}
			cd.appendChild(st);
		}
		if ( Validator.isString(ci.ttp) ) {
			cd.title = ci.ttp;
		}
		const sta = ci.sta;
		if ( sta === 'DON' || sta === 'CAN' ) {
			cd.className += ' gccdone';
			if ( sta === 'CAN' ) {
				cd.className += ' gcccancel';
			}
		} else if ( !!ci.fre ) {
			cd.className += ' gccdone';
		}
		ci.$el = cd;
		cd.__ci = ci;
		ci.vis = true;
		this._setItmVis(ci);
		if ( !!ci.oop ) {
			cd.style.display = 'none';
		}
		this._addEvtLis(ci);
		this.cldItm.push(ci);
		this.row.appendChild(cd);
	}

	_fndItm(gid) {
		let ci = null;
		if ( this.cldItm.length > 0 ) {
			const res = this.cldItm.filter(elm => elm.gid === gid);
			if ( res.length === 1 ) {
				ci = res[0];
			}
		}
		return ci;
	}

	_creNowOvl(mgr) {
		if ( this.blkDur && this.row ) {
			const ovl = document.createElement('div');
			ovl.className = 'gccnowovl';
			const brd = '1px solid ' + this.nowFgc;
			ovl.style.borderLeft = brd;
			ovl.style.borderRight = brd;
			if ( this.lstRow ) {
				ovl.style.borderBottom = brd;
			}
			this.nowBlk.ndiv = ovl;
			if ( this._plcNowOvl() ) {
				ovl.style.borderLeft = brd;
			}
			this.row.appendChild(ovl);
		}
	}

	_plcNowOvl() {
		let fst = false;
		if ( this.ready && this.row && this.nowBlk ) {
			const nbl = this.nowBlk;
			const ovl = nbl.ndiv;
			if ( ovl ) {
				const clr = this.row.getBoundingClientRect();
				const rct = nbl.bdiv.getBoundingClientRect();
				const wdt = rct.width;
				const par = {};
				par.x = rct.left - clr.left - 1;
				if ( par.x < 0 ) {
					par.x = 0;
					par.w = wdt;
					fst = true;
				} else {
					par.w = wdt + 1;
				}
				ovl.style.left = '' + par.x + 'px';
				ovl.style.width = '' + par.w + 'px';
				this._nfySrv('ovlRsz', par);
			}
		}
		return fst;
	}

	_dropOldItms() {
		this._clrNowBlk(false);
		if ( this.cldItm && this.cldItm.length ) {
			const cil = this.cldItm;
			for ( let i = cil.length; i > 0; --i ) {
				const ci = cil.pop();
				ci.$el = null;
			}
		}
		delete this.cldItm;
		if ( this.row ) {
			this.row.innerHTML = '';
		}
		this.cldItm = [];
	}

	_creNewItms(args) {
		this._dropOldItms();
		if ( this.row ) {
			const rct = this.row.getBoundingClientRect();
			const wdt = rct.width;
			const hgt = rct.height;
			const ofs = rct.left;
			const mgr = ItmMgr.getInst();
			const lim = args ? args.length || 0 : 0;
			for ( let i = 0; i < lim; ++i ) {
				this._creCldItm(mgr, args[i], wdt, hgt, ofs);
			}
			if ( this.nowBlk ) {
				this._creNowOvl(mgr);
			}
			this._updItmLay(this.cldItm);
		}
	}

	_updItmLay(cil) {
		const rows = [];
		const cnt = cil.length;
		for ( let i = 0; i < cnt; ++i ) {
			const ci = cil[i];
			if ( ci.vis ) {
				assignRow(rows, ci);
			}
		}
		for ( let i = 0; i < cnt; ++i ) {
			const ci = cil[i];
			if ( ci.vis ) {
				placeItem(rows, ci);
			}
		}
	}

	_addEvtLis(ci) {
		const scope = this;
		const click_lsr = function(e) { handleItemClick(e, scope, ci, false, false); };
		const dblclk_lsr = function(e) { handleItemClick(e, scope, ci, true, false); };
		const ctxclk_lsr = function(e) { handleItemClick(e, scope, ci, false, true); };
		const down_lsr = function(e) { handleMouseDown(e, scope, ci); };
		const msovr_lsr = function(e) { mouseOverItem(e, scope, ci); };
		const msout_lsr = function(e) { mouseOutItem(e, scope, ci); };
		ci.$el.addEventListener('mousedown', down_lsr);
		ci.$el.addEventListener('click', click_lsr);
		ci.$el.addEventListener('contextmenu', ctxclk_lsr);
		ci.$el.addEventListener('dblclick', dblclk_lsr);
		ci.$el.addEventListener('mouseover', msovr_lsr);
		ci.$el.addEventListener('mousemove', msovr_lsr);
		ci.$el.addEventListener('mouseout', msout_lsr);
	}

	_addGlbLis() {
		const scope = this;
		const click_lsr = function(e) { handleGlobalClick(e, scope); };
		const dblclk_lsr = function(e) { handleGlobalDblClk(e, scope); };
		const down_lsr = function(e) { handleRowMouseDown(e, scope); };
		const up_lsr = function(e) { handleRowMouseUp(e, scope); };
		const move_lsr = function(e) { handleRowMouseMove(e, scope); };
		const row = this.row;
		this.ttpMgr = new TtpMgr(this, row);
		row.addEventListener('mousedown', down_lsr);
		row.addEventListener('mouseup', up_lsr);
		row.addEventListener('mousemove', move_lsr);
		row.addEventListener('click', click_lsr);
		row.addEventListener('dblclick', dblclk_lsr);
		if ( typeof row.onauxclick !== 'undefined' ) {
			row.addEventListener('auxclick', click_lsr);
		}
	}

	setLstRow(args) {
		const lst = args || false;
		const chn = lst !== this.lstRow;
		this.lstRow = lst;
		if ( chn ) {
			this._clrNowBlk(false);
			if ( this.nowBlk ) {
				this._creNowOvl(ItmMgr.getInst());
			}
		}
	}

	setNewCldProp(args) {
		const redraw = !!args.redraw;
		let cld_items = [];
		if ( redraw ) {
			cld_items = Array.from(this.cldItm);
		}
		if ( args.effbeg ) {
			this.prdBeg = args.effbeg;
		} else if ( args.prdbeg ) {
			this.prdBeg = args.prdbeg;
		}
		if ( args.effend ) {
			this.prdEnd = args.effend;
		} else if ( args.prdend ) {
			this.prdEnd = args.prdend;
		}
		if ( args.blkdur ) {
			this.blkDur = args.blkdur;
		}
		if ( args.idr ) {
			this.rowID = args.idr;
		}
		if ( this.container && args.blocks && args.blocks.length ) {
			if ( args.lstitm ) {
				this.lstRow = true;
			}
			this._creBlocks(args.blocks, args.prdnam);
			if ( this.nowBlk ) {
				this._creNowOvl(ItmMgr.getInst());
			}
		}
		if ( redraw && (cld_items.length > 0) ) {
			const dataArgs = { data: cld_items };
			this.setNewCldData(dataArgs);
		}
	}

	setNewCldData(args) {
		if ( this.row ) {
			if ( args && args.data ) {
				if ( this.ready ) {
					this._creNewItms(args.data);
				} else {
					this.pndData = args.data;
				}
			}
		}
	}

	setShoDon(args) {
		const don = !!args;
		if ( don !== this.shoDon ) {
			this.shoDon = don;
			this._updAllVis();
		}
	}

	setShoCan(args) {
		const can = !!args;
		if ( can !== this.shoCan ) {
			this.shoCan = can;
			this._updAllVis();
		}
	}

	onNfyRsz() {
		this._plcNowOvl();
	}

	selItm(args) {
		const sel = !!args.sel;
		const ci = this._fndItm(args.gid);
		if ( ci ) {
			const scs = 'gccselected';
			let csn = ci.$el.className;
			if ( sel ) {
				csn += ' ' + scs;
			} else {
				csn = csn.replace(scs, '').trim();
			}
			ci.$el.className = csn;
		}
	}

	static register() {
		rap.registerTypeHandler("pisasales.GrcRow", {
			factory: function(properties) {
				return new GrcRow(properties);
			},
			destructor: "destroy",
			properties: [ "lstRow", "shoDon", "shoCan" ],
			methods: [ "onNfyRsz", "selItm", "setNewCldProp", "setNewCldData" ],
			events: [ "GRC_ROW_NFY" ]
		});
	}
}
